import { Mail, MapPin, Instagram, Linkedin } from "lucide-react";

export const Contact = () => {
  return (
    <section
      id="contato"
      data-testid="contact-section"
      className="relative bg-[#F4F4F0] bg-grain text-[#0B1015] py-24 md:py-36"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-4 text-[11px] uppercase tracking-[0.3em] text-[#475569]">
          <span className="flag-rule" aria-hidden />
          <span>§ 06 — Fale com a ABLEMP</span>
        </div>

        <div className="mt-10 grid grid-cols-12 gap-10">
          <div className="col-span-12 lg:col-span-7">
            <h2
              data-testid="contact-headline"
              className="font-serif-display text-[36px] sm:text-[48px] lg:text-[72px] leading-[1.02] tracking-[-0.02em]"
            >
              Imprensa, parceiros e cidadãos:{" "}
              <span className="italic font-light text-[#002776]">
                escreva
              </span>
              .
            </h2>
            <p className="mt-6 text-[#475569] text-lg leading-relaxed max-w-xl">
              Respondemos solicitações de imprensa, sugestões de pauta, apoio
              jurídico e propostas de parceria institucional. Toda mensagem é
              lida.
            </p>
          </div>

          <div className="col-span-12 lg:col-span-5">
            <div className="border border-[#0B1015]/15 bg-white">
              <ContactRow
                testid="contact-email"
                icon={Mail}
                label="E-mail"
                value="contato@ablemp.org.br"
                href="mailto:contato@ablemp.org.br"
              />
              <ContactRow
                testid="contact-location"
                icon={MapPin}
                label="Sede"
                value="Av. Paulista, 1636, Conj. 4, Pav. 15 · Bela Vista · São Paulo — SP · CEP 01.310-200"
              />
              <div className="flex items-center justify-between p-6">
                <span className="text-[10px] uppercase tracking-[0.3em] text-[#475569]">
                  Redes sociais
                </span>
                <div className="flex items-center gap-3">
                  <a
                    data-testid="contact-instagram"
                    href="#"
                    aria-label="Instagram"
                    className="h-10 w-10 grid place-items-center border border-[#0B1015]/20 hover:bg-[#0B1015] hover:text-white transition-colors"
                  >
                    <Instagram size={16} />
                  </a>
                  <a
                    data-testid="contact-linkedin"
                    href="#"
                    aria-label="LinkedIn"
                    className="h-10 w-10 grid place-items-center border border-[#0B1015]/20 hover:bg-[#0B1015] hover:text-white transition-colors"
                  >
                    <Linkedin size={16} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const ContactRow = ({ icon: Icon, label, value, href, testid }) => {
  const Comp = href ? "a" : "div";
  const props = href ? { href } : {};
  return (
    <Comp
      data-testid={testid}
      {...props}
      className="flex items-center justify-between p-6 border-b border-[#0B1015]/10 group hover:bg-[#F4F4F0] transition-colors"
    >
      <div className="flex items-center gap-4">
        <span className="h-10 w-10 grid place-items-center border border-[#0B1015]/15">
          <Icon size={16} strokeWidth={1.6} />
        </span>
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#475569]">
            {label}
          </div>
          <div className="font-serif-display text-lg mt-0.5">{value}</div>
        </div>
      </div>
      {href && (
        <span className="text-[11px] uppercase tracking-[0.3em] text-[#0B1015] editorial-link group-hover:active">
          Enviar
        </span>
      )}
    </Comp>
  );
};

export default Contact;
